<template>
  <div class="sd-pagination">
    <transition name="fade">
      <a class="sd-pagi-button sd-prev" @click="previous()" v-if="showPrev">
        <img src="/static/material_icons/arrow_left_white.png"
          v-bind:class="{ 'sd-pulse': (loader && isPrev)}"
        />
        <span>Vorherige</span>
      </a>
    </transition>
    <transition name="fade">
      <a class="sd-pagi-button sd-next" @click="next()" v-if="showNext">
        <span>Nächste</span>
        <img src="/static/material_icons/arrow_right_white.png"
          v-bind:class="{ 'sd-pulse': (loader && isNext)}"
        />
      </a>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'sd-pagination',
  props: [
    'isNext',
    'isPrev',
    'showNext',
    'showPrev',
    'next',
    'previous',
    'loader',
  ],
};
</script>

<style lang="scss">
@import "./../Globals.scss";

.sd-pagination {
  .sd-pagi-button {
    cursor: pointer;
    font-weight: bold;
    color: $sd-color-blue;
    display: table;

    &:hover {
      opacity: 0.8;
    }

    img {
      cursor: pointer;
      border-radius: 50%;
      height: 20px;
      width: 20px;
      background: $sd-color-blue;
      vertical-align: middle;
      display: table-cell;
    }

    span {
      padding: 0 5px 0 5px;
      vertical-align: middle;
      display: table-cell;
    }
  }

  .sd-next {
    float: right;
    margin-right: 20%;
  }

  .sd-prev {
    float: left;
    margin-left: 20%;
  }

  .sd-pulse {
    animation: pulse_animation 1.5s infinite;
  }
}

@keyframes pulse_animation {
  0% { transform: scale(1); }
  70% { transform: scale(0.7); }
  100% { transform: scale(1); }
}

@media (max-width: 750px) {
  .sd-pagination {
    .sd-pagi-button {
      span {
        display: none;
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// Pagination.vue?c29bbfcc